module.exports = __webpack_public_path__ + "assets/img/box3.bfc44f02.png";